/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import LatestBlogs from "./LatestBlogs";
import BannerCta from "./BannerCta";

export {
  LatestBlogs,
  BannerCta
};
